import * as Yup from "yup";

export function initialValues(user) {
  return {
    avatar: user?.avatar || "", // pregunta si hay un usuario y si lo hay coge el avatar si no coge un string vacio
    fileAvatar: null,
    firstname: user?.firstname || "",
    lastname: user?.lastname || "",
    email: user?.email || "",
    role: user?.role || "",
    idClient: user?.idClient || "",
    password: "", // aqui no lo hacemos porque  la contraseña no se puede mostrar
  };
}

export function validationSchema(user) {
  return Yup.object({
    firstname: Yup.string().required(true),
    lastname: Yup.string().required(true),
    email: Yup.string().email().required(true),
    role: Yup.string().required(true),
    idClient: Yup.string(),
    password: user ? Yup.string() : Yup.string().required(true), //la contraseña no es requerida si el usuario ya existe
  });
}
